import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ProcessPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const steps = [
    {
      number: '01',
      title: '初步諮詢',
      description: '了解您的資金需求或投資意向，提供初步評估與建議',
      icon: 'ri-chat-4-line',
      details: [
        '免費諮詢服務',
        '需求分析評估',
        '初步方案建議',
        '專業團隊回應'
      ]
    },
    {
      number: '02',
      title: '資料準備',
      description: '協助準備完整的申請文件與財務資料',
      icon: 'ri-file-list-3-line',
      details: [
        '財務報表整理',
        '營運計畫書撰寫',
        '法律文件準備',
        '資料完整性檢核'
      ]
    },
    {
      number: '03',
      title: '媒合配對',
      description: '根據需求媒合適合的資金方或投資標的',
      icon: 'ri-team-line',
      details: [
        '精準媒合配對',
        '多方案比較分析',
        '條件協商建議',
        '風險評估報告'
      ]
    },
    {
      number: '04',
      title: '盡職調查',
      description: '進行完整的背景調查與風險評估',
      icon: 'ri-search-eye-line',
      details: [
        '企業背景調查',
        '財務狀況分析',
        '產業趨勢研究',
        '風險因子評估'
      ]
    },
    {
      number: '05',
      title: '合約簽訂',
      description: '協助雙方完成合約審查與簽訂程序',
      icon: 'ri-file-edit-line',
      details: [
        '合約條款審查',
        '法律諮詢支援',
        '權益保障確認',
        '簽約流程協調'
      ]
    },
    {
      number: '06',
      title: '後續服務',
      description: '提供資金到位後的持續追蹤與管理服務',
      icon: 'ri-customer-service-2-line',
      details: [
        '進度追蹤管理',
        '問題協調處理',
        '營運狀況追蹤',
        '長期關係維護'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      <div className="pt-32 pb-24 bg-gradient-to-br from-black to-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-6">媒合流程</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            清楚透明的六步驟服務流程，確保媒合過程順利高效
          </p>
        </div>
      </div>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">專業的服務流程</h2>
            <div className="w-20 h-1 bg-black mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              從初步諮詢到資金到位，我們提供完整的專業服務，確保每個環節都能順利進行
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
            {steps.map((step, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-black transition-all hover:shadow-xl group"
              >
                <div className="flex items-center mb-6">
                  <div className="text-6xl font-bold text-black/20 group-hover:text-black/30 transition-colors mr-4">
                    {step.number}
                  </div>
                  <div className="w-16 h-16 bg-black/10 rounded-lg flex items-center justify-center group-hover:bg-black transition-colors">
                    <i className={`${step.icon} text-3xl text-black group-hover:text-white transition-colors`}></i>
                  </div>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{step.description}</p>
                
                <div className="space-y-2">
                  {step.details.map((detail, idx) => (
                    <div key={idx} className="flex items-center text-sm">
                      <i className="ri-checkbox-circle-line text-black mr-2"></i>
                      <span className="text-gray-600">{detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">為什麼選擇我們的服務？</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-time-line text-2xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">快速高效</h3>
                  <p className="text-gray-600">完善的流程管理系統，大幅縮短媒合時間，讓您快速取得所需資金或找到投資機會</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">專業可靠</h3>
                  <p className="text-gray-600">經驗豐富的金融顧問團隊，提供專業的評估與建議，確保媒合品質</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-eye-line text-2xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">透明公開</h3>
                  <p className="text-gray-600">清楚的流程說明與進度追蹤，讓您隨時掌握最新狀況，安心放心</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-customer-service-line text-2xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">全程服務</h3>
                  <p className="text-gray-600">從諮詢到簽約，再到後續追蹤，提供完整的一條龍服務，確保順利完成</p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/f6364d866b124a95b442fc62f2343a00.jpeg"
                alt="媒合流程"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">開始您的媒合之旅</h2>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                無論您是尋求資金的企業，或是希望投資的資金方，朋睿都能為您提供專業的媒合服務。
              </p>
              <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                立即聯繫我們，讓專業團隊為您評估需求，提供最適合的解決方案。
              </p>

              <div className="space-y-4">
                <a
                  href="https://line.me/R/ti/p/@678gwbht"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-full px-8 py-4 bg-black text-white rounded-full font-bold text-lg hover:bg-gray-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-chat-3-line text-2xl mr-3"></i>
                  LINE 諮詢
                </a>
                
                <a
                  href="/contact"
                  className="flex items-center justify-center w-full px-8 py-4 bg-white border-2 border-black text-black rounded-full font-bold text-lg hover:bg-gray-50 transition-colors whitespace-nowrap"
                >
                  <i className="ri-mail-line text-2xl mr-3"></i>
                  填寫表單
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}
